<div>
  <mat-form-field
    [class.light-form-field]="lightFormField"
    data-cy="demand-reason-select">
    <mat-label>{{
      label || (("reason" | i18n) || "Bestellgrund") + (required ? "" : "")
    }}</mat-label>
    <mat-select
      [ngModel]="selectedDemandReason$ | async"
      (ngModelChange)="onDemandReasonChange($event)"
      [disabled]="disabled"
      [required]="required"
      data-cy="demand-reason-select-input">
      <mat-option
        *ngIf="!required"
        [value]="null">
        {{ ("all" | i18n) || "Alle" | titlecase }}
      </mat-option>
      <mat-option
        *ngFor="let reason of demandReasons$ | async"
        [value]="reason"
        [attr.data-cy]="'demand-reason-select-option-' + reason.id">
        {{ reason.displayName | titlecase }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field
    *ngIf="
      showDescription &&
      (selectedDemandReason$ | async)?.enableDescription &&
      descriptionControl
    "
    [class.light-form-field]="lightFormField">
    <textarea
      matInput
      [formControl]="descriptionControl"
      [placeholder]="('description' | i18n) || 'Beschreibung' | titlecase"
      rows="2"
      data-cy="demand-reason-description-input">
    </textarea>
  </mat-form-field>
</div>
